import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {

    public getHost() {
        return this.retrieveBackend() || document.location.hostname;
    }

    public retrieveLanguage(): string {
        return localStorage.getItem('language') || '';
    }

    public storeLanguage(language: string): void {
        localStorage.setItem('language', language || '');
    }

    public retrieveUsername(): string {
        return localStorage.getItem('username') || '';
    }

    public storeUsername(username: string): void {
        localStorage.setItem('username', username || '');
    }

    public retrieveBackend(): string {
        return localStorage.getItem('backend') || '';
    }

    public storeBackend(backend: string): void {
        localStorage.setItem('backend', backend || '');
    }

    public removeBackend(): void {
        localStorage.removeItem('backend');
    }

    public retrieveLog(): string {
        return localStorage.getItem('log') || '';
    }

    public storeLog(log: string): void {
        localStorage.setItem('log', log || '');
    }

    public storeToken(token: string): void {
        sessionStorage.setItem('id_token', token || '');
    }

    public retrieveToken(): string {
        return sessionStorage.getItem('id_token');
    }

    public removeToken(): void {
        sessionStorage.removeItem('id_token');
    }

    public storeLoginDate(loginDate: string): void {
        sessionStorage.setItem('loginDate', loginDate || '');
    }

    public retrieveLoginDate(): string {
        return sessionStorage.getItem('loginDate');
    }

    public removeLoginDate(): void {
        sessionStorage.removeItem('loginDate');
    }

    public storeHostName(hostName: string): void {
        sessionStorage.setItem('hostName', hostName || '');
    }

    public retrieveHostName(): string {
        return sessionStorage.getItem('hostName');
    }

    public removeHostName(): void {
        sessionStorage.removeItem('hostName');
    }

     public get(key: string): string | null {
        return sessionStorage.getItem(key);
      }


}
